import styled, { css } from "styled-components";

import type { CheckBoxProps } from "./Checkbox";

export const StyledInput = styled.input`
  border: 0px;
  clip: rect(0px, 0px, 0px, 0px);
  cursor: pointer;
  height: 1px;
  margin: -1px;
  opacity: 0;
  overflow: hidden;
  padding: 0px;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;
StyledInput.displayName = "StyledInput";

export const StyledLabel = styled.label``;
StyledLabel.displayName = "StyledLabel";

export const StyledCheckbox = styled.div<
  Partial<CheckBoxProps & { $disabled: boolean }>
>`
  height: 16px;
  width: 16px;
  position: relative;
  transition-duration: 0.2s;
  border-radius: 2px;

  path {
    transition-duration: 0.2s;
    stroke: transparent;
    stroke-dashoffset: 12;
    stroke-dasharray: 12;
  }
  svg {
    cursor: pointer;
    border-radius: 2px;
    fill: transparent;
  }

  ${(props) =>
    props.$disabled &&
    css`
      svg {
        cursor: not-allowed;
      }
    `}

  rect {
    transition-duration: 0.2s;

    ${(props) =>
      !props.mixed &&
      css`
        stroke: var(--color-theme-500);
      `}

    ${(props) =>
      props.mixed &&
      css`
        stroke: transparent;
      `}
  }

  ${StyledInput}:disabled ~ ${StyledLabel} {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${StyledInput}:focus ~ ${StyledLabel} {
    ${(props) =>
      !props.mixed &&
      css`
        rect {
          stroke: var(--color-secondary);
          stroke-width: 3px;
        }
      `}
  }

  // prettier-ignore
  &:not(.c-checkbox__controlled) ${StyledInput}:hover:not(:checked) ~ ${StyledLabel} {
    path {
      stroke: var(--color-secondary-500);
      stroke-dashoffset: 24;
    }
    rect {
      stroke: var(--color-secondary);

      ${(props) =>
    props.mixed &&
    css`
      stroke: transparent;
    `}
      stroke-width: 3px;
    }
  }

  ${(props) =>
    props.hover &&
    !props.mixed &&
    css`
      ${StyledInput}:not(:checked) ~ ${StyledLabel} {
        path {
          stroke: var(--color-secondary-500);
          stroke-dashoffset: 24;
        }
        rect {
          stroke: var(--color-secondary);
          stroke-width: 3px;
        }
      }
    `}

  ${StyledInput}:checked ~ ${StyledLabel} {
    path {
      ${(props) =>
        !props.mixed &&
        css`
          stroke: var(--page-paper-main);
          stroke-dashoffset: 24;
        `}
    }
    rect {
      stroke: var(--color-secondary);
      stroke-width: 19px;

      ${(props) =>
        props.mixed &&
        css`
          stroke: transparent;
        `}
    }
  }
`;
StyledCheckbox.displayName = "StyledCheckbox";
